import { api } from './baseApi'
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    setProductStatus: build.mutation<SetProductStatusApiResponse, SetProductStatusApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/products/${queryArg.productId}/status`,
        method: 'PUT',
        body: queryArg.statusBody,
      }),
    }),
    setOrgStatus: build.mutation<SetOrgStatusApiResponse, SetOrgStatusApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/organizations/${queryArg.orgId}/status`,
        method: 'PUT',
        body: queryArg.orgStatusBody,
      }),
    }),
    setFeature: build.mutation<SetFeatureApiResponse, SetFeatureApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/organizations/${queryArg.orgId}/features/${queryArg.feature}`,
        method: 'PUT',
        body: queryArg.featureBody,
      }),
    }),
    setOrgFeature: build.mutation<SetOrgFeatureApiResponse, SetOrgFeatureApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/admin/organizations/${queryArg.orgId}/features/${queryArg.feature}`,
        method: 'PUT',
        body: queryArg.setFeatureBody,
      }),
    }),
    setOrgFeatureQuota: build.mutation<SetOrgFeatureQuotaApiResponse, SetOrgFeatureQuotaApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/admin/organizations/${queryArg.orgId}/features/${queryArg.feature}/quota`,
        method: 'PUT',
        body: queryArg.setQuotaBody,
      }),
    }),
    registerParticipant: build.mutation<RegisterParticipantApiResponse, RegisterParticipantApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/public/events/${queryArg.eventId}/register`,
        method: 'POST',
        body: queryArg.registerBody,
      }),
    }),
    listProducts: build.query<ListProductsApiResponse, ListProductsApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/products`,
        params: {
          orgId: queryArg.orgId,
          status: queryArg.status,
          page: queryArg.page,
          size: queryArg.size,
        },
      }),
    }),
    createProduct: build.mutation<CreateProductApiResponse, CreateProductApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/products`,
        method: 'POST',
        body: queryArg.createProductBody,
      }),
    }),
    getSupplyChain: build.query<GetSupplyChainApiResponse, GetSupplyChainApiArg>({
      query: (queryArg) => ({ url: `/api/v1/products/${queryArg.productId}/supply-chain` }),
    }),
    addSupplyChainEntry: build.mutation<AddSupplyChainEntryApiResponse, AddSupplyChainEntryApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/products/${queryArg.productId}/supply-chain`,
        method: 'POST',
        body: queryArg.supplyChainBody,
      }),
    }),
    shareProduct: build.mutation<ShareProductApiResponse, ShareProductApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/products/${queryArg.productId}/share`,
        method: 'POST',
        body: queryArg.shareBody,
      }),
    }),
    trackProduct: build.mutation<TrackProductApiResponse, TrackProductApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/products/track`,
        method: 'POST',
        body: queryArg.trackBody,
      }),
    }),
    listOrgs: build.query<ListOrgsApiResponse, ListOrgsApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/organizations`,
        params: {
          page: queryArg.page,
          size: queryArg.size,
        },
      }),
    }),
    createOrg: build.mutation<CreateOrgApiResponse, CreateOrgApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/organizations`,
        method: 'POST',
        body: queryArg.createOrgBody,
      }),
    }),
    shareOrg: build.mutation<ShareOrgApiResponse, ShareOrgApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/organizations/${queryArg.orgId}/share`,
        method: 'POST',
        body: queryArg.shareBody,
      }),
    }),
    requestUpgrade: build.mutation<RequestUpgradeApiResponse, RequestUpgradeApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/organizations/${queryArg.orgId}/plan/upgrade-request`,
        method: 'POST',
      }),
    }),
    cancelUpgrade: build.mutation<CancelUpgradeApiResponse, CancelUpgradeApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/organizations/${queryArg.orgId}/plan/upgrade-request`,
        method: 'DELETE',
      }),
    }),
    listOrders: build.query<ListOrdersApiResponse, ListOrdersApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/organizations/${queryArg.orgId}/orders`,
        params: {
          direction: queryArg.direction,
          status: queryArg.status,
          page: queryArg.page,
          size: queryArg.size,
        },
      }),
    }),
    createOrder: build.mutation<CreateOrderApiResponse, CreateOrderApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/organizations/${queryArg.orgId}/orders`,
        method: 'POST',
        body: queryArg.createOrderBody,
      }),
    }),
    registerItinerary: build.mutation<RegisterItineraryApiResponse, RegisterItineraryApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/organizations/${queryArg.orgId}/orders/${queryArg.orderId}/itinerary`,
        method: 'POST',
        body: queryArg.itineraryBody,
      }),
    }),
    advanceOrderStep: build.mutation<AdvanceOrderStepApiResponse, AdvanceOrderStepApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/organizations/${queryArg.orgId}/orders/${queryArg.orderId}/advance`,
        method: 'POST',
        body: queryArg.advanceBody,
      }),
    }),
    listMembers: build.query<ListMembersApiResponse, ListMembersApiArg>({
      query: (queryArg) => ({ url: `/api/v1/organizations/${queryArg.orgId}/members` }),
    }),
    inviteOrgMember: build.mutation<InviteOrgMemberApiResponse, InviteOrgMemberApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/organizations/${queryArg.orgId}/members`,
        method: 'POST',
        body: queryArg.inviteBody,
      }),
    }),
    resendOrgMemberInvitation: build.mutation<
      ResendOrgMemberInvitationApiResponse,
      ResendOrgMemberInvitationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/organizations/${queryArg.orgId}/members/${queryArg.invitationId}/resend`,
        method: 'POST',
      }),
    }),
    uploadLogo: build.mutation<UploadLogoApiResponse, UploadLogoApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/organizations/${queryArg.orgId}/logo`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    deleteOrgLogo: build.mutation<DeleteOrgLogoApiResponse, DeleteOrgLogoApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/organizations/${queryArg.orgId}/logo`,
        method: 'DELETE',
      }),
    }),
    listInvoices: build.query<ListInvoicesApiResponse, ListInvoicesApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/organizations/${queryArg.orgId}/invoices`,
        params: {
          direction: queryArg.direction,
          page: queryArg.page,
          size: queryArg.size,
        },
      }),
    }),
    createInvoice: build.mutation<CreateInvoiceApiResponse, CreateInvoiceApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/organizations/${queryArg.orgId}/invoices`,
        method: 'POST',
        body: queryArg.createInvoiceBody,
      }),
    }),
    sendInvoice: build.mutation<SendInvoiceApiResponse, SendInvoiceApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/organizations/${queryArg.orgId}/invoices/${queryArg.invoiceId}/send`,
        method: 'POST',
        body: queryArg.sendBody,
      }),
    }),
    linkInvoiceToOrder: build.mutation<LinkInvoiceToOrderApiResponse, LinkInvoiceToOrderApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/organizations/${queryArg.orgId}/invoices/${queryArg.invoiceId}/link-order`,
        method: 'POST',
        body: queryArg.linkOrderBody,
      }),
    }),
    listConnections: build.query<ListConnectionsApiResponse, ListConnectionsApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/organizations/${queryArg.orgId}/connections`,
        params: {
          type: queryArg['type'],
        },
      }),
    }),
    sendConnection: build.mutation<SendConnectionApiResponse, SendConnectionApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/organizations/${queryArg.orgId}/connections`,
        method: 'POST',
        body: queryArg.connectionBody,
      }),
    }),
    rejectConnection: build.mutation<RejectConnectionApiResponse, RejectConnectionApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/organizations/${queryArg.orgId}/connections/${queryArg.connectionId}/reject`,
        method: 'POST',
      }),
    }),
    approveConnection: build.mutation<ApproveConnectionApiResponse, ApproveConnectionApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/organizations/${queryArg.orgId}/connections/${queryArg.connectionId}/approve`,
        method: 'POST',
      }),
    }),
    join: build.mutation<JoinApiResponse, JoinApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/organizations/join`,
        method: 'POST',
        body: queryArg.joinBody,
      }),
    }),
    changePassword: build.mutation<ChangePasswordApiResponse, ChangePasswordApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/me/password`,
        method: 'POST',
        body: queryArg.changePasswordBody,
      }),
    }),
    logout: build.mutation<LogoutApiResponse, LogoutApiArg>({
      query: () => ({ url: `/api/v1/me/logout`, method: 'POST' }),
    }),
    listEvents: build.query<ListEventsApiResponse, ListEventsApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/events`,
        params: {
          orgId: queryArg.orgId,
          page: queryArg.page,
          size: queryArg.size,
        },
      }),
    }),
    createEvent: build.mutation<CreateEventApiResponse, CreateEventApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/events`,
        method: 'POST',
        body: queryArg.createEventBody,
      }),
    }),
    generateReport: build.mutation<GenerateReportApiResponse, GenerateReportApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/events/${queryArg.eventId}/reports/${queryArg.reportType}`,
        method: 'POST',
        params: {
          lang: queryArg.lang,
        },
      }),
    }),
    openRegistration: build.mutation<OpenRegistrationApiResponse, OpenRegistrationApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/events/${queryArg.eventId}/registration/open`,
        method: 'POST',
      }),
    }),
    closeRegistration: build.mutation<CloseRegistrationApiResponse, CloseRegistrationApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/events/${queryArg.eventId}/registration/close`,
        method: 'POST',
      }),
    }),
    listParticipants: build.query<ListParticipantsApiResponse, ListParticipantsApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/events/${queryArg.eventId}/participants`,
        params: {
          status: queryArg.status,
          offset: queryArg.offset,
          take: queryArg.take,
          sort: queryArg.sort,
          order: queryArg.order,
        },
      }),
    }),
    inviteParticipant: build.mutation<InviteParticipantApiResponse, InviteParticipantApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/events/${queryArg.eventId}/participants`,
        method: 'POST',
        body: queryArg.inviteBody,
      }),
    }),
    recordAttendanceAdmin: build.mutation<
      RecordAttendanceAdminApiResponse,
      RecordAttendanceAdminApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/events/${queryArg.eventId}/participants/${queryArg.participantId}/attendance`,
        method: 'POST',
      }),
    }),
    clearAttendanceAdmin: build.mutation<
      ClearAttendanceAdminApiResponse,
      ClearAttendanceAdminApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/events/${queryArg.eventId}/participants/${queryArg.participantId}/attendance`,
        method: 'DELETE',
      }),
    }),
    sendEventMediaNotifications: build.mutation<
      SendEventMediaNotificationsApiResponse,
      SendEventMediaNotificationsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/events/${queryArg.eventId}/participants/media/send`,
        method: 'POST',
        body: queryArg.sendEventMediaNotificationsBody,
      }),
    }),
    sendCertificatesOfAttendance: build.mutation<
      SendCertificatesOfAttendanceApiResponse,
      SendCertificatesOfAttendanceApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/events/${queryArg.eventId}/participants/certificates/send`,
        method: 'POST',
        body: queryArg.sendCertificatesBody,
      }),
    }),
    batchUpdateParticipants: build.mutation<
      BatchUpdateParticipantsApiResponse,
      BatchUpdateParticipantsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/events/${queryArg.eventId}/participants/batch`,
        method: 'POST',
        body: queryArg.batchBody,
      }),
    }),
    adminRegisterParticipant: build.mutation<
      AdminRegisterParticipantApiResponse,
      AdminRegisterParticipantApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/events/${queryArg.eventId}/participants/admin-register`,
        method: 'POST',
        body: queryArg.adminRegisterBody,
      }),
    }),
    listMedia: build.query<ListMediaApiResponse, ListMediaApiArg>({
      query: (queryArg) => ({ url: `/api/v1/events/${queryArg.eventId}/media` }),
    }),
    uploadMedia: build.mutation<UploadMediaApiResponse, UploadMediaApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/events/${queryArg.eventId}/media`,
        method: 'POST',
        body: queryArg.body,
        params: {
          mediaType: queryArg.mediaType,
        },
      }),
    }),
    uploadLogo1: build.mutation<UploadLogo1ApiResponse, UploadLogo1ApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/events/${queryArg.eventId}/logo`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    deleteLogo: build.mutation<DeleteLogoApiResponse, DeleteLogoApiArg>({
      query: (queryArg) => ({ url: `/api/v1/events/${queryArg.eventId}/logo`, method: 'DELETE' }),
    }),
    uploadFlyer: build.mutation<UploadFlyerApiResponse, UploadFlyerApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/events/${queryArg.eventId}/flyer`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    deleteFlyer: build.mutation<DeleteFlyerApiResponse, DeleteFlyerApiArg>({
      query: (queryArg) => ({ url: `/api/v1/events/${queryArg.eventId}/flyer`, method: 'DELETE' }),
    }),
    previewReminderEmail: build.mutation<
      PreviewReminderEmailApiResponse,
      PreviewReminderEmailApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/events/reminder-preview`,
        method: 'POST',
        body: queryArg.reminderPreviewBody,
      }),
    }),
    resendEventParticipantInvitation: build.mutation<
      ResendEventParticipantInvitationApiResponse,
      ResendEventParticipantInvitationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/events/participants/${queryArg.participantId}/resend`,
        method: 'POST',
      }),
    }),
    reopenRegistration: build.mutation<ReopenRegistrationApiResponse, ReopenRegistrationApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/events/participants/${queryArg.participantId}/reopen`,
        method: 'POST',
      }),
    }),
    rejectRegistration: build.mutation<RejectRegistrationApiResponse, RejectRegistrationApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/events/participants/${queryArg.participantId}/reject`,
        method: 'POST',
        body: queryArg.rejectBody,
      }),
    }),
    adminUploadPresentation: build.mutation<
      AdminUploadPresentationApiResponse,
      AdminUploadPresentationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/events/participants/${queryArg.participantId}/presentation/upload`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    askForPresentation: build.mutation<AskForPresentationApiResponse, AskForPresentationApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/events/participants/${queryArg.participantId}/presentation/remind`,
        method: 'POST',
        body: queryArg.presentationRemindBody,
      }),
    }),
    rejectPresentation: build.mutation<RejectPresentationApiResponse, RejectPresentationApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/events/participants/${queryArg.participantId}/presentation/reject`,
        method: 'POST',
        body: queryArg.presentationRejectBody,
      }),
    }),
    acceptPresentation: build.mutation<AcceptPresentationApiResponse, AcceptPresentationApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/events/participants/${queryArg.participantId}/presentation/accept`,
        method: 'POST',
        body: queryArg.presentationActionBody,
      }),
    }),
    acceptRegistration: build.mutation<AcceptRegistrationApiResponse, AcceptRegistrationApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/events/participants/${queryArg.participantId}/accept`,
        method: 'POST',
        body: queryArg.acceptBody,
      }),
    }),
    rsvp: build.mutation<RsvpApiResponse, RsvpApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/event/participant/rsvp`,
        method: 'POST',
        body: queryArg.rsvpBody,
      }),
    }),
    getPresentation: build.query<GetPresentationApiResponse, GetPresentationApiArg>({
      query: () => ({ url: `/api/v1/event/participant/presentation` }),
    }),
    uploadPresentation: build.mutation<UploadPresentationApiResponse, UploadPresentationApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/event/participant/presentation`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    deletePresentation: build.mutation<DeletePresentationApiResponse, DeletePresentationApiArg>({
      query: () => ({ url: `/api/v1/event/participant/presentation`, method: 'DELETE' }),
    }),
    recordAttendance: build.mutation<RecordAttendanceApiResponse, RecordAttendanceApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/event/participant/attendance`,
        method: 'POST',
        body: queryArg.recordAttendanceBody,
      }),
    }),
    rejectOrgUpgrade: build.mutation<RejectOrgUpgradeApiResponse, RejectOrgUpgradeApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/admin/organizations/${queryArg.orgId}/plan/reject`,
        method: 'POST',
      }),
    }),
    approveOrgUpgrade: build.mutation<ApproveOrgUpgradeApiResponse, ApproveOrgUpgradeApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/admin/organizations/${queryArg.orgId}/plan/approve`,
        method: 'POST',
      }),
    }),
    refreshTranslations: build.mutation<RefreshTranslationsApiResponse, RefreshTranslationsApiArg>({
      query: () => ({ url: `/api/v1/admin/i18n/refresh`, method: 'POST' }),
    }),
    getProduct: build.query<GetProductApiResponse, GetProductApiArg>({
      query: (queryArg) => ({ url: `/api/v1/products/${queryArg.productId}` }),
    }),
    updateProduct: build.mutation<UpdateProductApiResponse, UpdateProductApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/products/${queryArg.productId}`,
        method: 'PATCH',
        body: queryArg.updateProductBody,
      }),
    }),
    getOrg: build.query<GetOrgApiResponse, GetOrgApiArg>({
      query: (queryArg) => ({ url: `/api/v1/organizations/${queryArg.orgId}` }),
    }),
    deleteOrg: build.mutation<DeleteOrgApiResponse, DeleteOrgApiArg>({
      query: (queryArg) => ({ url: `/api/v1/organizations/${queryArg.orgId}`, method: 'DELETE' }),
    }),
    updateOrg: build.mutation<UpdateOrgApiResponse, UpdateOrgApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/organizations/${queryArg.orgId}`,
        method: 'PATCH',
        body: queryArg.updateOrgBody,
      }),
    }),
    getProfile: build.query<GetProfileApiResponse, GetProfileApiArg>({
      query: () => ({ url: `/api/v1/me` }),
    }),
    deleteAccount: build.mutation<DeleteAccountApiResponse, DeleteAccountApiArg>({
      query: () => ({ url: `/api/v1/me`, method: 'DELETE' }),
    }),
    updateProfile: build.mutation<UpdateProfileApiResponse, UpdateProfileApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/me`,
        method: 'PATCH',
        body: queryArg.updateProfileBody,
      }),
    }),
    markRead: build.mutation<MarkReadApiResponse, MarkReadApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/me/notifications/${queryArg.notificationId}/read`,
        method: 'PATCH',
      }),
    }),
    markAllRead: build.mutation<MarkAllReadApiResponse, MarkAllReadApiArg>({
      query: () => ({ url: `/api/v1/me/notifications/read-all`, method: 'PATCH' }),
    }),
    getEvent: build.query<GetEventApiResponse, GetEventApiArg>({
      query: (queryArg) => ({ url: `/api/v1/events/${queryArg.eventId}` }),
    }),
    deleteEvent: build.mutation<DeleteEventApiResponse, DeleteEventApiArg>({
      query: (queryArg) => ({ url: `/api/v1/events/${queryArg.eventId}`, method: 'DELETE' }),
    }),
    updateEvent: build.mutation<UpdateEventApiResponse, UpdateEventApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/events/${queryArg.eventId}`,
        method: 'PATCH',
        body: queryArg.updateEventBody,
      }),
    }),
    assignRole: build.mutation<AssignRoleApiResponse, AssignRoleApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/events/participants/${queryArg.participantId}/role`,
        method: 'PATCH',
        body: queryArg.assignRoleBody,
      }),
    }),
    setParticipantNote: build.mutation<SetParticipantNoteApiResponse, SetParticipantNoteApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/events/participants/${queryArg.participantId}/note`,
        method: 'PATCH',
        body: queryArg.setParticipantNoteBody,
      }),
    }),
    proxy: build.query<ProxyApiResponse, ProxyApiArg>({
      query: () => ({ url: `/api/v1/public/storage/**` }),
    }),
    getTranslations: build.query<GetTranslationsApiResponse, GetTranslationsApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/public/i18n/${queryArg.lang}/${queryArg['namespace']}`,
        headers: {
          'If-None-Match': queryArg['If-None-Match'],
        },
      }),
    }),
    getPublicEvent: build.query<GetPublicEventApiResponse, GetPublicEventApiArg>({
      query: (queryArg) => ({ url: `/api/v1/public/events/${queryArg.eventId}` }),
    }),
    getRegistrationStatus: build.query<
      GetRegistrationStatusApiResponse,
      GetRegistrationStatusApiArg
    >({
      query: (queryArg) => ({ url: `/api/v1/public/events/${queryArg.eventId}/registration` }),
    }),
    getEventLogo: build.query<GetEventLogoApiResponse, GetEventLogoApiArg>({
      query: (queryArg) => ({ url: `/api/v1/public/events/${queryArg.eventId}/logo` }),
    }),
    getEventFlyer: build.query<GetEventFlyerApiResponse, GetEventFlyerApiArg>({
      query: (queryArg) => ({ url: `/api/v1/public/events/${queryArg.eventId}/flyer` }),
    }),
    getProductStats: build.query<GetProductStatsApiResponse, GetProductStatsApiArg>({
      query: (queryArg) => ({ url: `/api/v1/products/${queryArg.productId}/stats` }),
    }),
    getOrgStats: build.query<GetOrgGetProductStatsApiResponse, GetOrgGetProductStatsApiArg>({
      query: (queryArg) => ({ url: `/api/v1/organizations/${queryArg.orgId}/stats` }),
    }),
    getQrScanHistory: build.query<GetQrScanHistoryApiResponse, GetQrScanHistoryApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/organizations/${queryArg.orgId}/qr-scans`,
        params: {
          page: queryArg.page,
          size: queryArg.size,
        },
      }),
    }),
    getPlan: build.query<GetPlanApiResponse, GetPlanApiArg>({
      query: (queryArg) => ({ url: `/api/v1/organizations/${queryArg.orgId}/plan` }),
    }),
    getOrder: build.query<GetOrderApiResponse, GetOrderApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/organizations/${queryArg.orgId}/orders/${queryArg.orderId}`,
      }),
    }),
    getItinerary: build.query<GetItineraryApiResponse, GetItineraryApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/organizations/${queryArg.orgId}/itineraries/${queryArg.itineraryId}`,
      }),
    }),
    getInvoice: build.query<GetInvoiceApiResponse, GetInvoiceApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/organizations/${queryArg.orgId}/invoices/${queryArg.invoiceId}`,
      }),
    }),
    listFeatures: build.query<ListFeaturesApiResponse, ListFeaturesApiArg>({
      query: (queryArg) => ({ url: `/api/v1/organizations/${queryArg.orgId}/features` }),
    }),
    getCapabilities: build.query<GetCapabilitiesApiResponse, GetCapabilitiesApiArg>({
      query: (queryArg) => ({ url: `/api/v1/organizations/${queryArg.orgId}/capabilities` }),
    }),
    lookupPostalCode: build.query<LookupPostalCodeApiResponse, LookupPostalCodeApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/organizations/postal-code`,
        params: {
          country: queryArg.country,
          code: queryArg.code,
        },
      }),
    }),
    getNotifications: build.query<GetNotificationsApiResponse, GetNotificationsApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/me/notifications`,
        params: {
          page: queryArg.page,
          size: queryArg.size,
        },
      }),
    }),
    deleteNotifications: build.mutation<DeleteNotificationsApiResponse, DeleteNotificationsApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/me/notifications`,
        method: 'DELETE',
        body: queryArg.deleteNotificationsBody,
      }),
    }),
    getCapabilities1: build.query<GetCapabilities1ApiResponse, GetCapabilities1ApiArg>({
      query: () => ({ url: `/api/v1/me/capabilities` }),
    }),
    getEventStats: build.query<GetEventGetProductStatsApiResponse, GetEventGetProductStatsApiArg>({
      query: (queryArg) => ({ url: `/api/v1/events/${queryArg.eventId}/stats` }),
    }),
    getScannerBundleAdmin: build.query<
      GetScannerBundleAdminApiResponse,
      GetScannerBundleAdminApiArg
    >({
      query: (queryArg) => ({ url: `/api/v1/events/${queryArg.eventId}/scanner-bundle` }),
    }),
    downloadCertificate: build.query<DownloadCertificateApiResponse, DownloadCertificateApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/events/${queryArg.eventId}/participants/${queryArg.participantId}/certificate`,
        params: {
          lang: queryArg.lang,
        },
      }),
    }),
    downloadMedia: build.query<DownloadMediaApiResponse, DownloadMediaApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/events/${queryArg.eventId}/media/${queryArg.mediaId}/download`,
      }),
    }),
    downloadMediaZip: build.query<DownloadMediaZipApiResponse, DownloadMediaZipApiArg>({
      query: (queryArg) => ({ url: `/api/v1/events/${queryArg.eventId}/media/zip` }),
    }),
    getParticipantTicketLink: build.query<
      GetParticipantTicketLinkApiResponse,
      GetParticipantTicketLinkApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/events/participants/${queryArg.participantId}/ticket-link`,
      }),
    }),
    downloadPresentation: build.query<DownloadPresentationApiResponse, DownloadPresentationApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/events/participants/${queryArg.participantId}/presentation/download`,
      }),
    }),
    getParticipantActivity: build.query<
      GetParticipantActivityApiResponse,
      GetParticipantActivityApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/events/participants/${queryArg.participantId}/activity`,
      }),
    }),
    getScannerBundle: build.query<GetScannerBundleApiResponse, GetScannerBundleApiArg>({
      query: () => ({ url: `/api/v1/event/participant/scanner-bundle` }),
    }),
    getQrCode: build.query<GetQrCodeApiResponse, GetQrCodeApiArg>({
      query: () => ({ url: `/api/v1/event/participant/qr-code` }),
    }),
    listMedia1: build.query<ListMedia1ApiResponse, ListMedia1ApiArg>({
      query: () => ({ url: `/api/v1/event/participant/media` }),
    }),
    downloadMedia1: build.query<DownloadMedia1ApiResponse, DownloadMedia1ApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/event/participant/media/${queryArg.mediaId}/download`,
      }),
    }),
    downloadOwnMediaZip: build.query<DownloadOwnMediaZipApiResponse, DownloadOwnMediaZipApiArg>({
      query: () => ({ url: `/api/v1/event/participant/media/zip` }),
    }),
    getMyParticipantProfile: build.query<
      GetMyParticipantProfileApiResponse,
      GetMyParticipantProfileApiArg
    >({
      query: () => ({ url: `/api/v1/event/participant/me` }),
    }),
    downloadIcs: build.query<DownloadIcsApiResponse, DownloadIcsApiArg>({
      query: () => ({ url: `/api/v1/event/participant/ics` }),
    }),
    downloadOwnCertificate: build.query<
      DownloadOwnCertificateApiResponse,
      DownloadOwnCertificateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/event/participant/certificate`,
        params: {
          lang: queryArg.lang,
        },
      }),
    }),
    listUsers: build.query<ListUsersApiResponse, ListUsersApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/admin/users`,
        params: {
          page: queryArg.page,
          size: queryArg.size,
        },
      }),
    }),
    listOrganizations: build.query<ListOrganizationsApiResponse, ListOrganizationsApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/admin/organizations`,
        params: {
          page: queryArg.page,
          size: queryArg.size,
        },
      }),
    }),
    listOrgUpgradeRequests: build.query<
      ListOrgUpgradeRequestsApiResponse,
      ListOrgUpgradeRequestsApiArg
    >({
      query: () => ({ url: `/api/v1/admin/organizations/upgrade-requests` }),
    }),
    listOrgFeatureRequests: build.query<
      ListOrgFeatureRequestsApiResponse,
      ListOrgFeatureRequestsApiArg
    >({
      query: () => ({ url: `/api/v1/admin/organizations/feature-requests` }),
    }),
    translationsStatus: build.query<TranslationsStatusApiResponse, TranslationsStatusApiArg>({
      query: () => ({ url: `/api/v1/admin/i18n/status` }),
    }),
    listAvailableFeatures: build.query<
      ListAvailableFeaturesApiResponse,
      ListAvailableFeaturesApiArg
    >({
      query: () => ({ url: `/api/v1/admin/features` }),
    }),
    removeMember: build.mutation<RemoveMemberApiResponse, RemoveMemberApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/organizations/${queryArg.orgId}/members/${queryArg.memberId}`,
        method: 'DELETE',
        body: queryArg.removeMemberBody,
      }),
    }),
    removeConnection: build.mutation<RemoveConnectionApiResponse, RemoveConnectionApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/organizations/${queryArg.orgId}/connections/${queryArg.connectionId}`,
        method: 'DELETE',
      }),
    }),
    deleteMedia: build.mutation<DeleteMediaApiResponse, DeleteMediaApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/events/${queryArg.eventId}/media/${queryArg.mediaId}`,
        method: 'DELETE',
      }),
    }),
    removeParticipant: build.mutation<RemoveParticipantApiResponse, RemoveParticipantApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/events/participants/${queryArg.participantId}`,
        method: 'DELETE',
      }),
    }),
  }),
  overrideExisting: false,
})
export { injectedRtkApi as engineApi }
export type SetProductStatusApiResponse = /** status 200 OK */ ApiError
export type SetProductStatusApiArg = {
  productId: string
  statusBody: StatusBody
}
export type SetOrgStatusApiResponse = /** status 200 OK */ ApiError
export type SetOrgStatusApiArg = {
  orgId: string
  orgStatusBody: OrgStatusBody
}
export type SetFeatureApiResponse = /** status 200 OK */ ApiError
export type SetFeatureApiArg = {
  orgId: string
  feature: string
  featureBody: FeatureBody
}
export type SetOrgFeatureApiResponse = /** status 200 OK */ ApiError
export type SetOrgFeatureApiArg = {
  orgId: string
  feature: string
  setFeatureBody: SetFeatureBody
}
export type SetOrgFeatureQuotaApiResponse = /** status 200 OK */ ApiError
export type SetOrgFeatureQuotaApiArg = {
  orgId: string
  feature: string
  setQuotaBody: SetQuotaBody
}
export type RegisterParticipantApiResponse = /** status 200 OK */ object
export type RegisterParticipantApiArg = {
  eventId: string
  registerBody: RegisterBody
}
export type ListProductsApiResponse = /** status 200 OK */ object
export type ListProductsApiArg = {
  orgId: string
  status?: string
  page?: number
  size?: number
}
export type CreateProductApiResponse = /** status 200 OK */ object
export type CreateProductApiArg = {
  createProductBody: CreateProductBody
}
export type GetSupplyChainApiResponse = /** status 200 OK */ object
export type GetSupplyChainApiArg = {
  productId: string
}
export type AddSupplyChainEntryApiResponse = /** status 200 OK */ object
export type AddSupplyChainEntryApiArg = {
  productId: string
  supplyChainBody: SupplyChainBody
}
export type ShareProductApiResponse = /** status 200 OK */ object
export type ShareProductApiArg = {
  productId: string
  shareBody: ShareBody
}
export type TrackProductApiResponse = /** status 200 OK */ ApiError
export type TrackProductApiArg = {
  trackBody: TrackBody
}
export type ListOrgsApiResponse = /** status 200 OK */ object
export type ListOrgsApiArg = {
  page?: number
  size?: number
}
export type CreateOrgApiResponse = /** status 200 OK */ object
export type CreateOrgApiArg = {
  createOrgBody: CreateOrgBody
}
export type ShareOrgApiResponse = /** status 200 OK */ object
export type ShareOrgApiArg = {
  orgId: string
  shareBody: ShareBody
}
export type RequestUpgradeApiResponse = /** status 200 OK */ ApiError
export type RequestUpgradeApiArg = {
  orgId: string
}
export type CancelUpgradeApiResponse = /** status 200 OK */ ApiError
export type CancelUpgradeApiArg = {
  orgId: string
}
export type ListOrdersApiResponse = /** status 200 OK */ object
export type ListOrdersApiArg = {
  orgId: string
  direction?: string
  status?: string
  page?: number
  size?: number
}
export type CreateOrderApiResponse = /** status 200 OK */ object
export type CreateOrderApiArg = {
  orgId: string
  createOrderBody: CreateOrderBody
}
export type RegisterItineraryApiResponse = /** status 200 OK */ object
export type RegisterItineraryApiArg = {
  orgId: string
  orderId: string
  itineraryBody: ItineraryBody
}
export type AdvanceOrderStepApiResponse = /** status 200 OK */ object
export type AdvanceOrderStepApiArg = {
  orgId: string
  orderId: string
  advanceBody: AdvanceBody
}
export type ListMembersApiResponse = /** status 200 OK */ object
export type ListMembersApiArg = {
  orgId: string
}
export type InviteOrgMemberApiResponse = /** status 200 OK */ object
export type InviteOrgMemberApiArg = {
  orgId: string
  inviteBody: InviteBody
}
export type ResendOrgMemberInvitationApiResponse = /** status 200 OK */ ApiError
export type ResendOrgMemberInvitationApiArg = {
  orgId: string
  invitationId: string
}
export type UploadLogoApiResponse = /** status 200 OK */ object
export type UploadLogoApiArg = {
  orgId: string
  body: {
    file: Blob
  }
}
export type DeleteOrgLogoApiResponse = /** status 200 OK */ object
export type DeleteOrgLogoApiArg = {
  orgId: string
}
export type ListInvoicesApiResponse = /** status 200 OK */ object
export type ListInvoicesApiArg = {
  orgId: string
  direction?: string
  page?: number
  size?: number
}
export type CreateInvoiceApiResponse = /** status 200 OK */ object
export type CreateInvoiceApiArg = {
  orgId: string
  createInvoiceBody: CreateInvoiceBody
}
export type SendInvoiceApiResponse = /** status 200 OK */ object
export type SendInvoiceApiArg = {
  orgId: string
  invoiceId: string
  sendBody: SendBody
}
export type LinkInvoiceToOrderApiResponse = /** status 200 OK */ object
export type LinkInvoiceToOrderApiArg = {
  orgId: string
  invoiceId: string
  linkOrderBody: LinkOrderBody
}
export type ListConnectionsApiResponse = /** status 200 OK */ object
export type ListConnectionsApiArg = {
  orgId: string
  type?: string
}
export type SendConnectionApiResponse = /** status 200 OK */ object
export type SendConnectionApiArg = {
  orgId: string
  connectionBody: ConnectionBody
}
export type RejectConnectionApiResponse = /** status 200 OK */ ApiError
export type RejectConnectionApiArg = {
  orgId: string
  connectionId: string
}
export type ApproveConnectionApiResponse = /** status 200 OK */ ApiError
export type ApproveConnectionApiArg = {
  orgId: string
  connectionId: string
}
export type JoinApiResponse = /** status 200 OK */ object
export type JoinApiArg = {
  joinBody: JoinBody
}
export type ChangePasswordApiResponse = /** status 200 OK */ ApiError
export type ChangePasswordApiArg = {
  changePasswordBody: ChangePasswordBody
}
export type LogoutApiResponse = /** status 200 OK */ ApiError
export type LogoutApiArg = void
export type ListEventsApiResponse = /** status 200 OK */ object
export type ListEventsApiArg = {
  orgId?: string
  page?: number
  size?: number
}
export type CreateEventApiResponse = /** status 200 OK */ object
export type CreateEventApiArg = {
  createEventBody: CreateEventBody
}
export type GenerateReportApiResponse = /** status 200 OK */ object
export type GenerateReportApiArg = {
  eventId: string
  reportType: string
  lang?: string
}
export type OpenRegistrationApiResponse = /** status 200 OK */ ApiError
export type OpenRegistrationApiArg = {
  eventId: string
}
export type CloseRegistrationApiResponse = /** status 200 OK */ ApiError
export type CloseRegistrationApiArg = {
  eventId: string
}
export type ListParticipantsApiResponse = /** status 200 OK */ object
export type ListParticipantsApiArg = {
  eventId: string
  status?: 'INVITED' | 'REGISTERED' | 'ACCEPTED' | 'DECLINED' | 'REJECTED' | 'ATTENDED'
  offset?: number
  take?: number
  sort?: string
  order?: string
}
export type InviteParticipantApiResponse = /** status 200 OK */ object
export type InviteParticipantApiArg = {
  eventId: string
  inviteBody: InviteBody
}
export type RecordAttendanceAdminApiResponse = /** status 200 OK */ object
export type RecordAttendanceAdminApiArg = {
  eventId: string
  participantId: string
}
export type ClearAttendanceAdminApiResponse = /** status 200 OK */ object
export type ClearAttendanceAdminApiArg = {
  eventId: string
  participantId: string
}
export type SendEventMediaNotificationsApiResponse = /** status 200 OK */ object
export type SendEventMediaNotificationsApiArg = {
  eventId: string
  sendEventMediaNotificationsBody: SendEventMediaNotificationsBody
}
export type SendCertificatesOfAttendanceApiResponse = /** status 200 OK */ object
export type SendCertificatesOfAttendanceApiArg = {
  eventId: string
  sendCertificatesBody: SendCertificatesBody
}
export type BatchUpdateParticipantsApiResponse = /** status 200 OK */ object
export type BatchUpdateParticipantsApiArg = {
  eventId: string
  batchBody: BatchBody
}
export type AdminRegisterParticipantApiResponse = /** status 200 OK */ object
export type AdminRegisterParticipantApiArg = {
  eventId: string
  adminRegisterBody: AdminRegisterBody
}
export type ListMediaApiResponse = /** status 200 OK */ object
export type ListMediaApiArg = {
  eventId: string
}
export type UploadMediaApiResponse = /** status 200 OK */ object
export type UploadMediaApiArg = {
  eventId: string
  mediaType: 'PHOTO' | 'VIDEO' | 'AUDIO' | 'PDF'
  body: {
    file: Blob
  }
}
export type UploadLogo1ApiResponse = /** status 200 OK */ object
export type UploadLogo1ApiArg = {
  eventId: string
  body: {
    file: Blob
  }
}
export type DeleteLogoApiResponse = /** status 200 OK */ object
export type DeleteLogoApiArg = {
  eventId: string
}
export type UploadFlyerApiResponse = /** status 200 OK */ object
export type UploadFlyerApiArg = {
  eventId: string
  body: {
    file: Blob
  }
}
export type DeleteFlyerApiResponse = /** status 200 OK */ object
export type DeleteFlyerApiArg = {
  eventId: string
}
export type PreviewReminderEmailApiResponse = /** status 200 OK */ object
export type PreviewReminderEmailApiArg = {
  reminderPreviewBody: ReminderPreviewBody
}
export type ResendEventParticipantInvitationApiResponse = /** status 200 OK */ ApiError
export type ResendEventParticipantInvitationApiArg = {
  participantId: string
}
export type ReopenRegistrationApiResponse = /** status 200 OK */ object
export type ReopenRegistrationApiArg = {
  participantId: string
}
export type RejectRegistrationApiResponse = /** status 200 OK */ object
export type RejectRegistrationApiArg = {
  participantId: string
  rejectBody: RejectBody
}
export type AdminUploadPresentationApiResponse = /** status 200 OK */ object
export type AdminUploadPresentationApiArg = {
  participantId: string
  body: {
    file: Blob
  }
}
export type AskForPresentationApiResponse = /** status 200 OK */ object
export type AskForPresentationApiArg = {
  participantId: string
  presentationRemindBody: PresentationRemindBody
}
export type RejectPresentationApiResponse = /** status 200 OK */ object
export type RejectPresentationApiArg = {
  participantId: string
  presentationRejectBody: PresentationRejectBody
}
export type AcceptPresentationApiResponse = /** status 200 OK */ object
export type AcceptPresentationApiArg = {
  participantId: string
  presentationActionBody: PresentationActionBody
}
export type AcceptRegistrationApiResponse = /** status 200 OK */ object
export type AcceptRegistrationApiArg = {
  participantId: string
  acceptBody: AcceptBody
}
export type RsvpApiResponse = /** status 200 OK */ ApiError
export type RsvpApiArg = {
  rsvpBody: RsvpBody
}
export type GetPresentationApiResponse = /** status 200 OK */ object
export type GetPresentationApiArg = void
export type UploadPresentationApiResponse = /** status 200 OK */ object
export type UploadPresentationApiArg = {
  body: {
    file: Blob
  }
}
export type DeletePresentationApiResponse = /** status 200 OK */ object
export type DeletePresentationApiArg = void
export type RecordAttendanceApiResponse = /** status 200 OK */ object
export type RecordAttendanceApiArg = {
  recordAttendanceBody: RecordAttendanceBody
}
export type RejectOrgUpgradeApiResponse = /** status 200 OK */ object
export type RejectOrgUpgradeApiArg = {
  orgId: string
}
export type ApproveOrgUpgradeApiResponse = /** status 200 OK */ object
export type ApproveOrgUpgradeApiArg = {
  orgId: string
}
export type RefreshTranslationsApiResponse = /** status 200 OK */ object
export type RefreshTranslationsApiArg = void
export type GetProductApiResponse = /** status 200 OK */ object
export type GetProductApiArg = {
  productId: string
}
export type UpdateProductApiResponse = /** status 200 OK */ ApiError
export type UpdateProductApiArg = {
  productId: string
  updateProductBody: UpdateProductBody
}
export type GetOrgApiResponse = /** status 200 OK */ object
export type GetOrgApiArg = {
  orgId: string
}
export type DeleteOrgApiResponse = /** status 200 OK */ ApiError
export type DeleteOrgApiArg = {
  orgId: string
}
export type UpdateOrgApiResponse = /** status 200 OK */ ApiError
export type UpdateOrgApiArg = {
  orgId: string
  updateOrgBody: UpdateOrgBody
}
export type GetProfileApiResponse = /** status 200 OK */ object
export type GetProfileApiArg = void
export type DeleteAccountApiResponse = /** status 200 OK */ ApiError
export type DeleteAccountApiArg = void
export type UpdateProfileApiResponse = /** status 200 OK */ ApiError
export type UpdateProfileApiArg = {
  updateProfileBody: UpdateProfileBody
}
export type MarkReadApiResponse = /** status 200 OK */ object
export type MarkReadApiArg = {
  notificationId: string
}
export type MarkAllReadApiResponse = /** status 200 OK */ object
export type MarkAllReadApiArg = void
export type GetEventApiResponse = /** status 200 OK */ object
export type GetEventApiArg = {
  eventId: string
}
export type DeleteEventApiResponse = /** status 200 OK */ ApiError
export type DeleteEventApiArg = {
  eventId: string
}
export type UpdateEventApiResponse = /** status 200 OK */ ApiError
export type UpdateEventApiArg = {
  eventId: string
  updateEventBody: UpdateEventBody
}
export type AssignRoleApiResponse = /** status 200 OK */ ApiError
export type AssignRoleApiArg = {
  participantId: string
  assignRoleBody: AssignRoleBody
}
export type SetParticipantNoteApiResponse = /** status 200 OK */ ApiError
export type SetParticipantNoteApiArg = {
  participantId: string
  setParticipantNoteBody: SetParticipantNoteBody
}
export type ProxyApiResponse = unknown
export type ProxyApiArg = void
export type GetTranslationsApiResponse = /** status 200 OK */ string
export type GetTranslationsApiArg = {
  lang: string
  namespace: string
  'If-None-Match'?: string
}
export type GetPublicEventApiResponse = /** status 200 OK */ object
export type GetPublicEventApiArg = {
  eventId: string
}
export type GetRegistrationStatusApiResponse = /** status 200 OK */ object
export type GetRegistrationStatusApiArg = {
  eventId: string
}
export type GetEventLogoApiResponse = /** status 200 OK */ string
export type GetEventLogoApiArg = {
  eventId: string
}
export type GetEventFlyerApiResponse = /** status 200 OK */ string
export type GetEventFlyerApiArg = {
  eventId: string
}
export type GetProductStatsApiResponse = /** status 200 OK */ object
export type GetProductStatsApiArg = {
  productId: string
}
export type GetOrgGetProductStatsApiResponse = /** status 200 OK */ object
export type GetOrgGetProductStatsApiArg = {
  orgId: string
}
export type GetQrScanHistoryApiResponse = /** status 200 OK */ object
export type GetQrScanHistoryApiArg = {
  orgId: string
  page?: number
  size?: number
}
export type GetPlanApiResponse = /** status 200 OK */ object
export type GetPlanApiArg = {
  orgId: string
}
export type GetOrderApiResponse = /** status 200 OK */ object
export type GetOrderApiArg = {
  orgId: string
  orderId: string
}
export type GetItineraryApiResponse = /** status 200 OK */ object
export type GetItineraryApiArg = {
  orgId: string
  itineraryId: string
}
export type GetInvoiceApiResponse = /** status 200 OK */ object
export type GetInvoiceApiArg = {
  orgId: string
  invoiceId: string
}
export type ListFeaturesApiResponse = /** status 200 OK */ object
export type ListFeaturesApiArg = {
  orgId: string
}
export type GetCapabilitiesApiResponse = /** status 200 OK */ GetOrgCapabilitiesResponse
export type GetCapabilitiesApiArg = {
  orgId: string
}
export type LookupPostalCodeApiResponse = /** status 200 OK */ object
export type LookupPostalCodeApiArg = {
  country: string
  code: string
}
export type GetNotificationsApiResponse = /** status 200 OK */ object
export type GetNotificationsApiArg = {
  page?: number
  size?: number
}
export type DeleteNotificationsApiResponse = /** status 200 OK */ object
export type DeleteNotificationsApiArg = {
  deleteNotificationsBody: DeleteNotificationsBody
}
export type GetCapabilities1ApiResponse = /** status 200 OK */ GetCapabilitiesResponse
export type GetCapabilities1ApiArg = void
export type GetEventGetProductStatsApiResponse = /** status 200 OK */ object
export type GetEventGetProductStatsApiArg = {
  eventId: string
}
export type GetScannerBundleAdminApiResponse = /** status 200 OK */ object
export type GetScannerBundleAdminApiArg = {
  eventId: string
}
export type DownloadCertificateApiResponse = /** status 200 OK */ object
export type DownloadCertificateApiArg = {
  eventId: string
  participantId: string
  lang?: string
}
export type DownloadMediaApiResponse = /** status 200 OK */ object
export type DownloadMediaApiArg = {
  eventId: string
  mediaId: string
}
export type DownloadMediaZipApiResponse = /** status 200 OK */ object
export type DownloadMediaZipApiArg = {
  eventId: string
}
export type GetParticipantTicketLinkApiResponse = /** status 200 OK */ object
export type GetParticipantTicketLinkApiArg = {
  participantId: string
}
export type DownloadPresentationApiResponse = /** status 200 OK */ object
export type DownloadPresentationApiArg = {
  participantId: string
}
export type GetParticipantActivityApiResponse = /** status 200 OK */ object
export type GetParticipantActivityApiArg = {
  participantId: string
}
export type GetScannerBundleApiResponse = /** status 200 OK */ object
export type GetScannerBundleApiArg = void
export type GetQrCodeApiResponse = /** status 200 OK */ object
export type GetQrCodeApiArg = void
export type ListMedia1ApiResponse = /** status 200 OK */ object
export type ListMedia1ApiArg = void
export type DownloadMedia1ApiResponse = /** status 200 OK */ object
export type DownloadMedia1ApiArg = {
  mediaId: string
}
export type DownloadOwnMediaZipApiResponse = /** status 200 OK */ object
export type DownloadOwnMediaZipApiArg = void
export type GetMyParticipantProfileApiResponse = /** status 200 OK */ object
export type GetMyParticipantProfileApiArg = void
export type DownloadIcsApiResponse = /** status 200 OK */ object
export type DownloadIcsApiArg = void
export type DownloadOwnCertificateApiResponse = /** status 200 OK */ object
export type DownloadOwnCertificateApiArg = {
  lang?: string
}
export type ListUsersApiResponse = /** status 200 OK */ object
export type ListUsersApiArg = {
  page?: number
  size?: number
}
export type ListOrganizationsApiResponse = /** status 200 OK */ object
export type ListOrganizationsApiArg = {
  page?: number
  size?: number
}
export type ListOrgUpgradeRequestsApiResponse = /** status 200 OK */ object
export type ListOrgUpgradeRequestsApiArg = void
export type ListOrgFeatureRequestsApiResponse = /** status 200 OK */ object
export type ListOrgFeatureRequestsApiArg = void
export type TranslationsStatusApiResponse = /** status 200 OK */ object
export type TranslationsStatusApiArg = void
export type ListAvailableFeaturesApiResponse = /** status 200 OK */ object
export type ListAvailableFeaturesApiArg = void
export type RemoveMemberApiResponse = /** status 200 OK */ ApiError
export type RemoveMemberApiArg = {
  orgId: string
  memberId: string
  removeMemberBody: RemoveMemberBody
}
export type RemoveConnectionApiResponse = /** status 200 OK */ ApiError
export type RemoveConnectionApiArg = {
  orgId: string
  connectionId: string
}
export type DeleteMediaApiResponse = /** status 200 OK */ object
export type DeleteMediaApiArg = {
  eventId: string
  mediaId: string
}
export type RemoveParticipantApiResponse = /** status 200 OK */ ApiError
export type RemoveParticipantApiArg = {
  participantId: string
}
export type ApiError = {
  code?: string
  message?: string
  timestamp?: string
}
export type StatusBody = {
  status?: string
}
export type OrgStatusBody = {
  status?: string
  message?: string
  notify?: boolean
}
export type FeatureBody = {
  enabled?: boolean
}
export type SetFeatureBody = {
  enabled?: boolean
}
export type SetQuotaBody = {
  maxUsage?: number
}
export type RegisterBody = {
  firstName?: string
  lastName?: string
  email?: string
  companyName?: string
  consentDataCollection?: boolean
  consentMediaRecording?: boolean
  language?: string
}
export type CreateProductBody = {
  orgId?: string
  name?: string
  description?: string
  idLotto?: string
  visibility?: string
  externalLink?: string
}
export type SupplyChainBody = {
  organizationId?: string
  organizationName?: string
  date?: string
  location?: string
}
export type ShareBody = {
  channel?: string
}
export type TrackBody = {
  productId?: string
  organizationId?: string
  channel?: string
}
export type OrgAddress = {
  region?: string
  postalCode?: string
  city?: string
  street?: string
  building?: string
  additional?: string
  country?: string
}
export type OrgContact = {
  name?: string
  email?: string
  phone?: string
}
export type CreateOrgBody = {
  name?: string
  description?: string
  endpointId?: string
  logoUrl?: string
  address?: OrgAddress
  contact?: OrgContact
}
export type CreateOrderBody = {
  productId?: string
  buyerOrgId?: string
  quantity?: number
  unit?: string
  deliveryAddress?: string
  scheduledAt?: string
  note?: string
}
export type ItineraryBody = {
  route?: string
}
export type AdvanceBody = {
  action?: string
}
export type InviteBody = {
  email?: string
  firstName?: string
  lastName?: string
}
export type PartyBody = {
  participantId?: string
  name?: string
  country?: string
  postalCode?: string
  region?: string
  city?: string
  street?: string
  building?: string
  additional?: string
}
export type LineItemBody = {
  lineId?: string
  itemName?: string
  description?: string
  quantity?: number
  unit?: string
  priceAmount?: number
  taxCategory?: string
}
export type PrecedingInvoiceRef = {
  identifier?: string
  issueDate?: string
}
export type AdditionalInfoBody = {
  note?: string
  buyerRef?: string
  purchaseOrderRef?: string
  saleOrderRef?: string
  contractRef?: string
  despatchAdviceRef?: string
  receiptAdviceRef?: string
  tenderOrLotRef?: string
  precedingInvoices?: PrecedingInvoiceRef[]
}
export type CreateInvoiceBody = {
  issueDate?: string
  identifier?: string
  billingPeriodStart?: string
  billingPeriodEnd?: string
  paymentDueDate?: string
  taxPointDate?: string
  seller?: PartyBody
  buyer?: PartyBody
  currency?: string
  lineItems?: LineItemBody[]
  additionalInfo?: AdditionalInfoBody
  orderId?: string
}
export type SendBody = {
  channel?: string
}
export type LinkOrderBody = {
  orderId?: string
}
export type ConnectionBody = {
  targetOrgId?: string
}
export type JoinBody = {
  token?: string
}
export type ChangePasswordBody = {
  newPassword?: string
}
export type CreateEventBody = {
  orgId?: string
  title?: string
  description?: string
  startDate?: string
  endDate?: string
  venue?: string
  venueMapUrl?: string
  primaryColor?: string
  fontFamily?: string
  qrActivationDate?: string
  reminderAt?: string
  registrationClosesAt?: string
  ticketAnnouncement?: string
  backgroundColor?: string
  textColor?: string
  accentColor?: string
  headingFontFamily?: string
  timezone?: string
}
export type SendEventMediaNotificationsBody = {
  participantIds?: string[]
}
export type SendCertificatesBody = {
  participantIds?: string[]
  language?: string
}
export type BatchBody = {
  participantIds?: string[]
  action?: string
  sendEmailNotification?: boolean
  rejectionMessage?: string
  presentationMessage?: string
  reminderMessages?: {
    [key: string]: string
  }
  role?: 'AUDIENCE' | 'SPEAKER' | 'STAFF' | 'HOST'
}
export type AdminRegisterBody = {
  firstName?: string
  lastName?: string
  email?: string
  companyName?: string
  organizerConsentConfirmed?: boolean
  consentMediaRecording?: boolean
  sendEmailNotification?: boolean
  role?: 'AUDIENCE' | 'SPEAKER' | 'STAFF' | 'HOST'
  language?: string
}
export type ReminderPreviewBody = {
  title?: string
  startDate?: string
  venue?: string
  timezone?: string
  primaryColor?: string
  backgroundColor?: string
  participantName?: string
  previewAsOf?: string
  language?: string
}
export type RejectBody = {
  sendEmailNotification?: boolean
  rejectionMessage?: string
}
export type PresentationRemindBody = {
  customMessage?: string
}
export type PresentationRejectBody = {
  sendEmailNotification?: boolean
  rejectionMessage?: string
}
export type PresentationActionBody = {
  sendEmailNotification?: boolean
}
export type AcceptBody = {
  sendEmailNotification?: boolean
  role?: 'AUDIENCE' | 'SPEAKER' | 'STAFF' | 'HOST'
}
export type RsvpBody = {
  accepted?: boolean
}
export type RecordAttendanceBody = {
  targetParticipantId?: string
}
export type UpdateProductBody = {
  name?: string
  description?: string
  idLotto?: string
  visibility?: string
  externalLink?: string
}
export type UpdateOrgBody = {
  name?: string
  description?: string
  logoUrl?: string
  address?: OrgAddress
}
export type UpdateProfileBody = {
  firstName?: string
  lastName?: string
}
export type UpdateEventBody = {
  title?: string
  description?: string
  startDate?: string
  endDate?: string
  venue?: string
  venueMapUrl?: string
  status?: 'DRAFT' | 'PUBLISHED' | 'COMPLETED'
  primaryColor?: string
  fontFamily?: string
  qrActivationDate?: string
  clearQrActivationDate?: boolean
  reminderAt?: string
  registrationManualState?: string
  registrationClosesAt?: string
  ticketAnnouncement?: string
  backgroundColor?: string
  textColor?: string
  accentColor?: string
  headingFontFamily?: string
  timezone?: string
}
export type AssignRoleBody = {
  role?: 'AUDIENCE' | 'SPEAKER' | 'STAFF' | 'HOST'
  sendEmailNotification?: boolean
  message?: string
}
export type SetParticipantNoteBody = {
  note?: string
  sendEmailNotification?: boolean
}
export type GetOrgCapabilitiesResponse = {
  canUpdateOrg?: boolean
  canDeleteOrg?: boolean
  canInviteMembers?: boolean
  canSetFeature?: boolean
  canRequestPlanUpgrade?: boolean
}
export type DeleteNotificationsBody = {
  notificationIds?: string[]
}
export type GetCapabilitiesResponse = {
  canRead?: boolean
  canWrite?: boolean
  canAccessOwnOrg?: boolean
  canAccessService?: boolean
  isAdmin?: boolean
  canCreateEvent?: boolean
}
export type RemoveMemberBody = {
  sendEmailNotification?: boolean
}
export const {
  useSetProductStatusMutation,
  useSetOrgStatusMutation,
  useSetFeatureMutation,
  useSetOrgFeatureMutation,
  useSetOrgFeatureQuotaMutation,
  useRegisterParticipantMutation,
  useListProductsQuery,
  useCreateProductMutation,
  useGetSupplyChainQuery,
  useAddSupplyChainEntryMutation,
  useShareProductMutation,
  useTrackProductMutation,
  useListOrgsQuery,
  useCreateOrgMutation,
  useShareOrgMutation,
  useRequestUpgradeMutation,
  useCancelUpgradeMutation,
  useListOrdersQuery,
  useCreateOrderMutation,
  useRegisterItineraryMutation,
  useAdvanceOrderStepMutation,
  useListMembersQuery,
  useInviteOrgMemberMutation,
  useResendOrgMemberInvitationMutation,
  useUploadLogoMutation,
  useDeleteOrgLogoMutation,
  useListInvoicesQuery,
  useCreateInvoiceMutation,
  useSendInvoiceMutation,
  useLinkInvoiceToOrderMutation,
  useListConnectionsQuery,
  useSendConnectionMutation,
  useRejectConnectionMutation,
  useApproveConnectionMutation,
  useJoinMutation,
  useChangePasswordMutation,
  useLogoutMutation,
  useListEventsQuery,
  useCreateEventMutation,
  useGenerateReportMutation,
  useOpenRegistrationMutation,
  useCloseRegistrationMutation,
  useListParticipantsQuery,
  useInviteParticipantMutation,
  useRecordAttendanceAdminMutation,
  useClearAttendanceAdminMutation,
  useSendEventMediaNotificationsMutation,
  useSendCertificatesOfAttendanceMutation,
  useBatchUpdateParticipantsMutation,
  useAdminRegisterParticipantMutation,
  useListMediaQuery,
  useUploadMediaMutation,
  useUploadLogo1Mutation,
  useDeleteLogoMutation,
  useUploadFlyerMutation,
  useDeleteFlyerMutation,
  usePreviewReminderEmailMutation,
  useResendEventParticipantInvitationMutation,
  useReopenRegistrationMutation,
  useRejectRegistrationMutation,
  useAdminUploadPresentationMutation,
  useAskForPresentationMutation,
  useRejectPresentationMutation,
  useAcceptPresentationMutation,
  useAcceptRegistrationMutation,
  useRsvpMutation,
  useGetPresentationQuery,
  useUploadPresentationMutation,
  useDeletePresentationMutation,
  useRecordAttendanceMutation,
  useRejectOrgUpgradeMutation,
  useApproveOrgUpgradeMutation,
  useRefreshTranslationsMutation,
  useGetProductQuery,
  useUpdateProductMutation,
  useGetOrgQuery,
  useDeleteOrgMutation,
  useUpdateOrgMutation,
  useGetProfileQuery,
  useDeleteAccountMutation,
  useUpdateProfileMutation,
  useMarkReadMutation,
  useMarkAllReadMutation,
  useGetEventQuery,
  useDeleteEventMutation,
  useUpdateEventMutation,
  useAssignRoleMutation,
  useSetParticipantNoteMutation,
  useProxyQuery,
  useGetTranslationsQuery,
  useGetPublicEventQuery,
  useGetRegistrationStatusQuery,
  useGetEventLogoQuery,
  useGetEventFlyerQuery,
  useGetProductStatsQuery,
  useGetOrgStatsQuery,
  useGetQrScanHistoryQuery,
  useGetPlanQuery,
  useGetOrderQuery,
  useGetItineraryQuery,
  useGetInvoiceQuery,
  useListFeaturesQuery,
  useGetCapabilitiesQuery,
  useLookupPostalCodeQuery,
  useGetNotificationsQuery,
  useDeleteNotificationsMutation,
  useGetCapabilities1Query,
  useGetEventStatsQuery,
  useGetScannerBundleAdminQuery,
  useDownloadCertificateQuery,
  useDownloadMediaQuery,
  useDownloadMediaZipQuery,
  useGetParticipantTicketLinkQuery,
  useDownloadPresentationQuery,
  useGetParticipantActivityQuery,
  useGetScannerBundleQuery,
  useGetQrCodeQuery,
  useListMedia1Query,
  useDownloadMedia1Query,
  useDownloadOwnMediaZipQuery,
  useGetMyParticipantProfileQuery,
  useDownloadIcsQuery,
  useDownloadOwnCertificateQuery,
  useListUsersQuery,
  useListOrganizationsQuery,
  useListOrgUpgradeRequestsQuery,
  useListOrgFeatureRequestsQuery,
  useTranslationsStatusQuery,
  useListAvailableFeaturesQuery,
  useRemoveMemberMutation,
  useRemoveConnectionMutation,
  useDeleteMediaMutation,
  useRemoveParticipantMutation,
} = injectedRtkApi
